export default "__VITE_ASSET__91276668__"